/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'
import * as FeedDefs from '../feed/defs.defs.js'

const $nsid = 'app.bsky.unspecced.defs'

export { $nsid }

type SkeletonSearchPost = {
  $type?: 'app.bsky.unspecced.defs#skeletonSearchPost'
  uri: l.AtUriString
}

export type { SkeletonSearchPost }

const skeletonSearchPost = l.typedObject<SkeletonSearchPost>(
  $nsid,
  'skeletonSearchPost',
  l.object({ uri: l.string({ format: 'at-uri' }) }),
)

export { skeletonSearchPost }

type SkeletonSearchActor = {
  $type?: 'app.bsky.unspecced.defs#skeletonSearchActor'
  did: l.DidString
}

export type { SkeletonSearchActor }

const skeletonSearchActor = l.typedObject<SkeletonSearchActor>(
  $nsid,
  'skeletonSearchActor',
  l.object({ did: l.string({ format: 'did' }) }),
)

export { skeletonSearchActor }

type SkeletonSearchStarterPack = {
  $type?: 'app.bsky.unspecced.defs#skeletonSearchStarterPack'
  uri: l.AtUriString
}

export type { SkeletonSearchStarterPack }

const skeletonSearchStarterPack = l.typedObject<SkeletonSearchStarterPack>(
  $nsid,
  'skeletonSearchStarterPack',
  l.object({ uri: l.string({ format: 'at-uri' }) }),
)

export { skeletonSearchStarterPack }

type TrendingTopic = {
  $type?: 'app.bsky.unspecced.defs#trendingTopic'
  topic: string
  displayName?: string
  description?: string
  link: string
}

export type { TrendingTopic }

const trendingTopic = l.typedObject<TrendingTopic>(
  $nsid,
  'trendingTopic',
  l.object({
    topic: l.string(),
    displayName: l.optional(l.string()),
    description: l.optional(l.string()),
    link: l.string(),
  }),
)

export { trendingTopic }

type SkeletonTrend = {
  $type?: 'app.bsky.unspecced.defs#skeletonTrend'
  topic: string
  displayName: string
  link: string
  startedAt: l.DatetimeString
  postCount: number
  status?: 'hot' | l.UnknownString
  category?: string
  dids: l.DidString[]
}

export type { SkeletonTrend }

const skeletonTrend = l.typedObject<SkeletonTrend>(
  $nsid,
  'skeletonTrend',
  l.object({
    topic: l.string(),
    displayName: l.string(),
    link: l.string(),
    startedAt: l.string({ format: 'datetime' }),
    postCount: l.integer(),
    status: l.optional(l.string<{ knownValues: ['hot'] }>()),
    category: l.optional(l.string()),
    dids: l.array(l.string({ format: 'did' })),
  }),
)

export { skeletonTrend }

type TrendView = {
  $type?: 'app.bsky.unspecced.defs#trendView'
  topic: string
  displayName: string
  link: string
  startedAt: l.DatetimeString
  postCount: number
  status?: 'hot' | l.UnknownString
  category?: string
  actors: ActorDefs.ProfileViewBasic[]
}

export type { TrendView }

const trendView = l.typedObject<TrendView>(
  $nsid,
  'trendView',
  l.object({
    topic: l.string(),
    displayName: l.string(),
    link: l.string(),
    startedAt: l.string({ format: 'datetime' }),
    postCount: l.integer(),
    status: l.optional(l.string<{ knownValues: ['hot'] }>()),
    category: l.optional(l.string()),
    actors: l.array(
      l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { trendView }

type ThreadItemPost = {
  $type?: 'app.bsky.unspecced.defs#threadItemPost'
  post: FeedDefs.PostView

  /**
   * This post has more parents that were not present in the response. This is just a boolean, without the number of parents.
   */
  moreParents: boolean

  /**
   * This post has more replies that were not present in the response. This is a numeric value, which is best-effort and might not be accurate.
   */
  moreReplies: number

  /**
   * This post is part of a contiguous thread by the OP from the thread root. Many different OP threads can happen in the same thread.
   */
  opThread: boolean

  /**
   * The threadgate created by the author indicates this post as a reply to be hidden for everyone consuming the thread.
   */
  hiddenByThreadgate: boolean

  /**
   * This is by an account muted by the viewer requesting it.
   */
  mutedByViewer: boolean
}

export type { ThreadItemPost }

const threadItemPost = l.typedObject<ThreadItemPost>(
  $nsid,
  'threadItemPost',
  l.object({
    post: l.ref<FeedDefs.PostView>((() => FeedDefs.postView) as any),
    moreParents: l.boolean(),
    moreReplies: l.integer(),
    opThread: l.boolean(),
    hiddenByThreadgate: l.boolean(),
    mutedByViewer: l.boolean(),
  }),
)

export { threadItemPost }

type ThreadItemNoUnauthenticated = {
  $type?: 'app.bsky.unspecced.defs#threadItemNoUnauthenticated'
}

export type { ThreadItemNoUnauthenticated }

const threadItemNoUnauthenticated = l.typedObject<ThreadItemNoUnauthenticated>(
  $nsid,
  'threadItemNoUnauthenticated',
  l.object({}),
)

export { threadItemNoUnauthenticated }

type ThreadItemNotFound = {
  $type?: 'app.bsky.unspecced.defs#threadItemNotFound'
}

export type { ThreadItemNotFound }

const threadItemNotFound = l.typedObject<ThreadItemNotFound>(
  $nsid,
  'threadItemNotFound',
  l.object({}),
)

export { threadItemNotFound }

type ThreadItemBlocked = {
  $type?: 'app.bsky.unspecced.defs#threadItemBlocked'
  author: FeedDefs.BlockedAuthor
}

export type { ThreadItemBlocked }

const threadItemBlocked = l.typedObject<ThreadItemBlocked>(
  $nsid,
  'threadItemBlocked',
  l.object({
    author: l.ref<FeedDefs.BlockedAuthor>(
      (() => FeedDefs.blockedAuthor) as any,
    ),
  }),
)

export { threadItemBlocked }

/** The computed state of the age assurance process, returned to the user in question on certain authenticated requests. */
type AgeAssuranceState = {
  $type?: 'app.bsky.unspecced.defs#ageAssuranceState'

  /**
   * The timestamp when this state was last updated.
   */
  lastInitiatedAt?: l.DatetimeString

  /**
   * The status of the age assurance process.
   */
  status: 'unknown' | 'pending' | 'assured' | 'blocked' | l.UnknownString
}

export type { AgeAssuranceState }

/** The computed state of the age assurance process, returned to the user in question on certain authenticated requests. */
const ageAssuranceState = l.typedObject<AgeAssuranceState>(
  $nsid,
  'ageAssuranceState',
  l.object({
    lastInitiatedAt: l.optional(l.string({ format: 'datetime' })),
    status: l.string<{
      knownValues: ['unknown', 'pending', 'assured', 'blocked']
    }>(),
  }),
)

export { ageAssuranceState }

/** Object used to store age assurance data in stash. */
type AgeAssuranceEvent = {
  $type?: 'app.bsky.unspecced.defs#ageAssuranceEvent'

  /**
   * The date and time of this write operation.
   */
  createdAt: l.DatetimeString

  /**
   * The status of the age assurance process.
   */
  status: 'unknown' | 'pending' | 'assured' | l.UnknownString

  /**
   * The unique identifier for this instance of the age assurance flow, in UUID format.
   */
  attemptId: string

  /**
   * The email used for AA.
   */
  email?: string

  /**
   * The IP address used when initiating the AA flow.
   */
  initIp?: string

  /**
   * The user agent used when initiating the AA flow.
   */
  initUa?: string

  /**
   * The IP address used when completing the AA flow.
   */
  completeIp?: string

  /**
   * The user agent used when completing the AA flow.
   */
  completeUa?: string
}

export type { AgeAssuranceEvent }

/** Object used to store age assurance data in stash. */
const ageAssuranceEvent = l.typedObject<AgeAssuranceEvent>(
  $nsid,
  'ageAssuranceEvent',
  l.object({
    createdAt: l.string({ format: 'datetime' }),
    status: l.string<{ knownValues: ['unknown', 'pending', 'assured'] }>(),
    attemptId: l.string(),
    email: l.optional(l.string()),
    initIp: l.optional(l.string()),
    initUa: l.optional(l.string()),
    completeIp: l.optional(l.string()),
    completeUa: l.optional(l.string()),
  }),
)

export { ageAssuranceEvent }
